import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "bar", "percentage", "stepInfo"]
  static values = { 
    completedSteps: Array,
    currentStep: String,
    progress: Number
  }

  connect() {
    this.updateProgressDisplay()
    this.highlightCurrentStep()
  }

  completedStepsValueChanged() {
    this.updateProgressDisplay()
  }

  currentStepValueChanged() {
    this.highlightCurrentStep()
  }

  progressValueChanged() {
    this.updateProgressBar()
  }

  updateProgressDisplay() {
    // Update step indicators
    this.stepTargets.forEach(stepElement => {
      const stepName = stepElement.dataset.stepName
      
      if (this.completedStepsValue.includes(stepName)) {
        stepElement.classList.add("completed")
        stepElement.classList.remove("pending", "current")
        
        // Update icon to checkmark
        const icon = stepElement.querySelector(".step-icon")
        if (icon) {
          icon.innerHTML = `
            <svg class="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
            </svg>
          `
        }
      } else if (stepName === this.currentStepValue) {
        stepElement.classList.add("current")
        stepElement.classList.remove("completed", "pending")
      } else {
        stepElement.classList.add("pending")
        stepElement.classList.remove("completed", "current")
      }
    })

    // Update progress bar
    this.updateProgressBar()
  }

  highlightCurrentStep() {
    this.stepTargets.forEach(stepElement => {
      const stepName = stepElement.dataset.stepName
      
      if (stepName === this.currentStepValue && !this.completedStepsValue.includes(stepName)) {
        stepElement.classList.add("current")
        stepElement.classList.remove("completed", "pending")
        
        // Pulse animation for current step
        stepElement.classList.add("animate-pulse")
        setTimeout(() => {
          stepElement.classList.remove("animate-pulse")
        }, 2000)
      }
    })
  }

  updateProgressBar() {
    if (this.hasBarTarget) {
      this.barTarget.style.width = `${this.progressValue}%`
      this.barTarget.setAttribute('aria-valuenow', this.progressValue)
    }

    if (this.hasPercentageTarget) {
      this.percentageTarget.textContent = `${this.progressValue}% Complete`
    }

    // Update step info
    if (this.hasStepInfoTarget) {
      const totalSteps = this.stepTargets.length
      const completedCount = this.completedStepsValue.length
      this.stepInfoTarget.textContent = `Step ${completedCount + 1} of ${totalSteps}`
    }
  }

  goToStep(event) {
    const stepName = event.currentTarget.dataset.stepName
    
    // Check if step is accessible (completed or current)
    if (this.completedStepsValue.includes(stepName) || stepName === this.currentStepValue) {
      // Update the hidden current_step field
      const stepField = document.querySelector('input[name="application[current_step]"]')
      if (stepField) {
        stepField.value = stepName
        
        // Submit the form to navigate to the step
        const form = stepField.closest('form')
        if (form) {
          // Add a flag to indicate navigation
          const navigationFlag = document.createElement('input')
          navigationFlag.type = 'hidden'
          navigationFlag.name = 'navigate_to_step'
          navigationFlag.value = 'true'
          form.appendChild(navigationFlag)
          
          form.requestSubmit()
        }
      }
    } else {
      // Show message that step is not yet accessible
      this.showStepNotAccessible(stepName)
    }
  }

  showStepNotAccessible(stepName) {
    const message = document.createElement('div')
    message.className = 'fixed top-4 right-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded shadow-lg z-50'
    message.innerHTML = `
      <div class="flex items-center">
        <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
        </svg>
        <span>Please complete previous steps first</span>
      </div>
    `
    
    document.body.appendChild(message)
    
    setTimeout(() => {
      message.remove()
    }, 3000)
  }
}